export default "__VITE_ASSET__h_ygu7HA__"